<empusa-range-slider *ngIf="parsedToSliderValues" [values]="parsedToSliderValues"
                     (onSliderChange)="onSliderSelection($event)"
                     [cssSliderStyles]="cssStylesForSlider" [initialValues]="initialSliderValues">
</empusa-range-slider>
